import Slider from './AwesomeSlider';

export default Slider;